import cn from 'classnames';

import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	progress: 'chat' | 'tags' | 'filters' | 'results' | 'export';
	onClick?: () => void;
}

export const Header = ({ progress, onClick }: Props) => {
	return (
		<div className={styles.container}>
			<div className={styles.progress}>
				<div className={styles.progressTitle}>
					{progress === 'tags' || progress === 'chat' ? (
						<div
							className={cn(styles.outline, {
								[styles.outlineActive]: progress === 'tags' || progress === 'chat'
							})}>
							<Text
								variant="inter/13/medium"
								color={progress === 'tags' || progress === 'chat' ? 'blue_new' : 'darker_grey'}>
								1
							</Text>
						</div>
					) : (
						<Icon icon="check-bold" size={16} className={styles.icon} />
					)}
					<Text
						variant="inter/13/medium"
						color={progress === 'tags' || progress === 'chat' ? 'blue_new' : 'grey'}>
						Build a list of technology skills
					</Text>
				</div>
				<div
					className={cn(styles.progressBar, {
						[styles.progressBarActive]: progress === 'tags' || progress === 'filters'
					})}
				/>
				<div className={styles.progressTitle}>
					{progress === 'results' ? (
						<Icon icon="check-bold" size={16} className={styles.icon} />
					) : (
						<div
							className={cn(styles.outline, {
								[styles.outlineActive]: progress === 'filters'
							})}>
							<Text variant="inter/13/medium" color={progress === 'filters' ? 'blue_new' : 'darker_grey'}>
								2
							</Text>
						</div>
					)}
					<Text variant="inter/13/medium" color={progress === 'filters' ? 'blue_new' : 'grey'}>
						Add company and people filters
					</Text>
				</div>
				<div
					className={cn(styles.progressBar, {
						[styles.progressBarActive]: progress === 'filters' || progress === 'results'
					})}
				/>
				<div className={styles.progressTitle}>
					<div
						className={cn(styles.outline, {
							[styles.outlineActive]: progress === 'results'
						})}>
						<Text variant="inter/13/medium" color={progress === 'results' ? 'blue_new' : 'darker_grey'}>
							3
						</Text>
					</div>
					<Text variant="inter/13/medium" color={progress === 'results' ? 'blue_new' : 'grey'}>
						Search results
					</Text>
				</div>
				<div
					className={cn(styles.progressBar, {
						[styles.progressBarActive]: progress === 'results' || progress === 'export'
					})}
				/>
				<div className={styles.progressTitle}>
					<div
						className={cn(styles.outline, {
							[styles.outlineActive]: progress === 'export'
						})}>
						<Text variant="inter/13/medium" color={progress === 'export' ? 'blue_new' : 'darker_grey'}>
							4
						</Text>
					</div>
					<Text variant="inter/13/medium" color={progress === 'export' ? 'blue_new' : 'grey'}>
						Export data
					</Text>
				</div>
				{progress !== 'chat' && (
					<div className={styles.back}>
						<div className={styles.backButton} onClick={onClick}>
							<Icon icon="arrow-left" size={24} className={styles.backIcon} />
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
